module.exports = __webpack_public_path__ + "static/img/so.89f77f80.svg";